import { TargetingReadOnlyList } from '@openx/components-package/components/PackageDetails/sections/TargetingReadOnlyList';
import { useFilteredTargetingItems } from '@openx/components-package/utils/hooks/useFilteredTargetingItems';
import type { PackageFormState } from '@openx/types/package';

type SelectedPackageDetailsProps = {
  packageState: PackageFormState;
};

export const SelectedPackageDetails = ({ packageState }: SelectedPackageDetailsProps) => {
  const targeting = useFilteredTargetingItems(packageState);

  return <TargetingReadOnlyList targeting={targeting} packageState={packageState} validateLegacyViewFormat={true} />;
};
